import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import styles from './ListSlatePlugin.scss'
import { onClickButton } from './ListSlatePluginContainer'
import { FaListUl, FaListOl } from 'react-icons/lib/fa'

class ListButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, onChange, style } = this.props

    const customStyle = {}

    return (
      <Button
        id={'ListButton' + this.uid}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState, this.props.listType))}
        color='secondary'
        className={styles.ListButton}
      >
        { this.props.listType === 'ul_list' ? <FaListUl /> : <FaListOl /> }
      </Button>
    )
  }
}

ListButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  listType: PropTypes.oneOf(['ul_list', 'ol_list']),
  style: PropTypes.object
}

export default ListButton



// WEBPACK FOOTER //
// ./src/components/ListSlatePlugin/ListButton.js